import { render, staticRenderFns } from "./AppRepos.vue?vue&type=template&id=6e87add1&"
import script from "./AppRepos.vue?vue&type=script&lang=js&"
export * from "./AppRepos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports